import { bemClassNames } from "@multiweb/reactUtils";

export const GRID_PARTICIPANTS_ITEM_CLASS_NAME = bemClassNames("grid-participants-item");
